import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-terms-and-condition',
  templateUrl: './redirect-terms-and-condition.component.html',
  styleUrls: ['./redirect-terms-and-condition.component.css']
})
export class RedirectTermsAndConditionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
